// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/7c04e25ed3ef8a1cd7ce.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b55a8b711bec57e349ce","139":"abe9dc3423463401291d","140":"b420eca9c21c76dcca1f"}[chunkId] + ".chunk.js";
};